import { CardFooter } from '@/components/ui/card'
import {
  getEstateStats,
  GetEstateStatsProps,
} from '@/estate/utils/getEstateStats'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type EstatesCardFooterProps = GetEstateStatsProps
export const EstatesCardFooter = (props: EstatesCardFooterProps) => {
  const { t } = useTranslation()
  const { nbPlannedVisits, nbDoneVisits, nbDrafts, nbSubmissions } =
    getEstateStats(props)

  return (
    <CardFooter className="tw-flex tw-justify-between tw-items-center tw-gap-4">
      <div className="tw-font-medium tw-text-xs tw-flex tw-flex-wrap tw-max-w-16 tw-space-y-1">
        <p>
          {t('EstatesCardList.footer.visitsPlanned', {
            count: nbPlannedVisits,
          })}
        </p>
      </div>
      <div className="tw-font-medium tw-text-xs tw-flex tw-flex-wrap tw-max-w-16 tw-space-y-1">
        <p>
          {t('EstatesCardList.footer.visitsDone', {
            count: nbDoneVisits,
          })}
        </p>
      </div>
      <div className="tw-font-medium tw-text-xs tw-flex tw-flex-wrap tw-max-w-16 tw-space-y-1">
        <p>
          {t('EstatesCardList.footer.offersPrepared', {
            count: nbDrafts,
          })}
        </p>
      </div>
      <div className="tw-font-medium tw-text-xs tw-flex tw-flex-wrap tw-max-w-16 tw-space-y-1">
        <p>
          {t('EstatesCardList.footer.offersReceived', {
            count: nbSubmissions,
          })}
        </p>
      </div>
    </CardFooter>
  )
}
